import type { ResourceEndpoints } from '../core'

export const accountsEndpoints = {
  collection: '/api/v1/accounts',
  item: (id: string) => `/api/v1/accounts/${encodeURIComponent(id)}`,
} satisfies ResourceEndpoints
